import React, { createContext, useContext, ReactNode } from 'react';
import { Location } from '../Clients/reminds';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useApiClientContext } from './ApiClient.Context';

interface ContextType {
  data: Location[] | undefined;
  deleteLocation: (id: number) => void;
}

const Context = createContext<ContextType | undefined>(undefined);

export const useLocationsContext = () => {
  const context = useContext(Context);
  if (!context) {
    throw new Error('useLocationsContext must be used within a LocationsProvider');
  }
  return context;
};

interface Props {
  children: ReactNode;
}

export const LocationsProvider: React.FC<Props> = ({ children }) => {
  const { locationsClient } = useApiClientContext();
  const queryClient = useQueryClient();

  const { data } = useQuery({
    queryKey: ['locations'],
    queryFn: () => locationsClient.getLocations(),
  });

  const { mutate } = useMutation({
    mutationFn: (id: number) => locationsClient.deleteLocation(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['locations'] });
    },
    onError: error => {
      console.error('Error deleting grocery item:', error);
    },
  });

  return <Context.Provider value={{ data, deleteLocation: mutate }}>{children}</Context.Provider>;
};
